import { Button, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useState } from "react";
import { renderClose } from "../../common/dialog";
import { createEntityStore } from "../../common/entityStore";
import { propTextField } from "../../common/entityStoreForm";
import { propLengthMax, propRequired } from "../../common/entityStoreValidators";
import { CollectionAgencyEditDto, newCollectionAgency } from "./types";
import { useCollectionAgencies } from "../../common/enum";

export const CollectionAgencyDialog = (props: {
    close: () => void;
    collectionAgency: CollectionAgencyEditDto | null;
    onChange(): void;
}) => {
    const [useStore] = useState(() => createEntityStore<CollectionAgencyEditDto>({
        data: props.collectionAgency === null ? newCollectionAgency() : { ...props.collectionAgency },
        path: "settings/collectionAgency",
        fetchOnInit: false,
        id: props.collectionAgency != null ? props.collectionAgency.id : null,
        getNewId: p => p.id!,
        onSaved() {
            props.onChange();
            props.close();
            useCollectionAgencies.getState().uninit();
        },
        propValidators: [
            propRequired("name"),
            propLengthMax("name", 50),
        ]
    }));
    const { save, id, isSaveDisabled } = useStore(p => ({ save: p.save, id: p.entityId, isSaveDisabled: p.isSaveDisabled }));
    return <>
        <DialogTitle>{id == null ? `New collection agency` : `Edit collection agency - ${props.collectionAgency?.name}`}</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            <Grid container columnSpacing={2} alignItems="stretch">
                <Grid item xs={12}>{propTextField(useStore)("name", "Name")}</Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button onClick={save} disabled={isSaveDisabled} color="save">Save</Button>
            <Button onClick={props.close} color="negative" variant="outlined">Close</Button>
        </DialogActions>
    </>;
};